import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getTokenRoles } from '../utils/jwt-roles';

export const useAuthRedirect = (redirectPath: string = '/') => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      setIsChecking(false);
      return;
    }

    try {
      const decoded: any = jwtDecode(token);
      const nowInSeconds = Date.now() / 1000;

      if (!decoded?.exp || decoded.exp <= nowInSeconds) {
        setIsChecking(false);
        return;
      }

      const roles = getTokenRoles(decoded);

      // Login sonrasında gelen ama henüz 2FA verify yapılmamış token
      if (roles.includes('VerifyCode')) {
        setIsChecking(false);
        return;
      }

      // Zorunlu şifre değiştirme token'ı — change-pass'e yönlendir
      if (roles.includes('ChangeExpirePassword') || roles.includes('ChangePassword')) {
        navigate('/authentication/change-pass', { replace: true });
        return;
      }

      // Tam oturum açık — anasayfaya yönlendir
      navigate(redirectPath, { replace: true });
    } catch {
      localStorage.removeItem('accessToken');
      setIsChecking(false);
    }
  }, [navigate, redirectPath]);

  return { isChecking };
};
